import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function settingsRoutes($stateProvider: StateProvider) {
    let settingsModule: { default: any; };
    $stateProvider
        .state({
            name: 'settings',
            url: '/settings?q&section',
            params: {q: {dynamic: true}, section: {dynamic: true}},
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => settingsModule.default,
            },
            lazyLoad: async () => {
                settingsModule = await import(/* webpackChunkName: "settings" */ './KpSettingsPage.svelte');
                return null;
            }
        });
}